jQuery(document).ready( function() {
  jQuery(".personalizeOpt").on('change', function(el){
    var ogPrice = parseInt(jQuery("#price").data("price"));
  	console.log("PRICE: " + ogPrice);
    var engraving = jQuery(".personalizeOpt option:selected");
    var engravingPrice = parseInt(jQuery(".personalizeOpt option:selected").data('price'));
    var newPrice = ogPrice + engravingPrice;
    newPrice = "$" + newPrice;
    console.log(newPrice);
    if( jQuery('.comparePrice').length ) {
      jQuery(".productPrice").html(newPrice);
    } else {
      jQuery("#price").html(newPrice);  
    }
    if(engraving.val() == "None") {
      $(".personalisationSelect").css({opacity:0}).delay(2000).css("position", "absolute");
      $("input#personalization").val("");
      $("input#personalization").removeAttr('class');
      $("input#personalization").removeAttr('data-error');
    } else {
      $(".personalisationSelect").css("position", "relative");
      $(".personalisationSelect").css({opacity:1});
      $("input#personalization").attr('class', 'required');
      $("input#personalization").attr('data-error', 'Please input your personalization');
    }
  });
  
  jQuery('#Quantity').on('change', function() {
    var quant = jQuery("#Quantity option:selected").data('amount');
    var ogPrice = parseInt(jQuery("#price").data("price"));
    var quantPrice = 0;
    if(quant == 'single') {
      quantPrice = ogPrice;
    } else {
      quantPrice = ogPrice * 2;
    }
    quantPrice = "$" + quantPrice;
    if( jQuery('.comparePrice').length ) {
      jQuery(".productPrice").html(newPrice);
    } else {
      jQuery("#price").html(newPrice);  
    }  
  });
  
  jQuery('#addToCart').on('click', function(event){
      event.preventDefault();
      var product = $('form[action="/cart/add"]').serializeArray();
      var productInfo = [];
      var productAdded = false;
      $.each( product, function( i, field ) {
        var fieldName = field.name.replace("properties[", "");
        fieldName = fieldName.replace("]", "");
        fieldName = fieldName.toLowerCase();
        productInfo[fieldName] = field.value;
      });
      console.log(productInfo);
      if(productInfo['engravingtype'] === undefined) {
        if($(".productSelect option:selected").text() != "None" && $("#personalization").val() != "" && $(".sizeSelect option:selected").text() != "Please Select") {
          if($("#bundleIDs").length) {
            var bundleIDs = $("#bundleIDs").text().trim();
            bundleIDs = bundleIDs.slice(0, -1);
            bundleIDs = bundleIDs.replaceAll("ID=", "");
            bundleIDs = bundleIDs.split(",");
            //console.log(bundleIDs);
            $.each(bundleIDs, function(key, value) {
              	var bundleID = value;
              	console.log("Adding product to cart: ", bundleID);
              	console.log("Amount: ", productInfo["quantity"]);
            	CartJS.addItem(bundleID, productInfo["quantity"]);
            });
            productAdded = true;
          } else {
            CartJS.addItem(productInfo["id"], productInfo["quantity"], {
              "Personalization" : productInfo["personalization"]
            });
            productAdded = true;
          }
        } else if($(".productSelect option:selected").text() != "None" && $("#personalization").val() == "" && $(".sizeSelect option:selected").text() == "Please Select") {
          $(".addError").html("Error: Please enter your personalization and size.");
          $(".addError").fadeIn();
        } else if($(".productSelect option:selected").text() != "None" && $("#personalization").val() == "") {
          $(".addError").html("Error: Please enter your personalization.");
          $(".addError").fadeIn();
        } else if($(".sizeSelect option:selected").text() == "Please Select") {
          $(".addError").html("Error: Please select a size.");
          $(".addError").fadeIn();
        } else {
          if($("#bundleIDs").length) {
            var bundleIDs = $("#bundleIDs").text().trim();
            bundleIDs = bundleIDs.slice(0, -1);
            bundleIDs = bundleIDs.replaceAll("ID=", "");
            bundleIDs = bundleIDs.split(",");
            //console.log(bundleIDs);
            $.each(bundleIDs, function(key, value) {
              	var bundleID = value;
              	console.log("Adding product to cart 2", bundleID);
              	console.log("Amount: ", productInfo["quantity"]);
            	CartJS.addItem(bundleID, productInfo["quantity"]);
            });
            productAdded = true;
          } else {
            CartJS.addItem(productInfo["id"], productInfo["quantity"], {
              "Personalization" : productInfo["personalization"]
            });
            productAdded = true;
          }
        }
      } else {
        if(productInfo['engravingtype'] != "None" && $("#personalization").val() != "" && $(".sizeSelect option:selected").text() != "Please Select") {
          var engravingFor = productInfo["productsku"] + " - " + productInfo["productname"];
          CartJS.addItem(productInfo["engravingtype"], productInfo["quantity"], {
            "Text" : productInfo["personalization"],
            "Personalization for" : engravingFor
          });
          CartJS.addItem(productInfo["id"], productInfo["quantity"]);
          productAdded = true;
        } else if(productInfo['engravingtype'] != "None" && $("#personalization").val() == "" && $(".sizeSelect option:selected").text() == "Please Select") {
          $(".addError").html("Error: Please enter your personalization and size.");
          $(".addError").fadeIn();
        } else if(productInfo['engravingtype'] != "None" && $("#personalization").val() == "") {
          $(".addError").html("Error: Please enter your personalization.");
          $(".addError").fadeIn();
        } else if($(".sizeSelect option:selected").text() == "Please Select") {
          $(".addError").html("Error: Please select a size.");
          $(".addError").fadeIn();
        } else {
          if($("#bundleIDs").length) {
            var bundleIDs = $("#bundleIDs").text().trim();
            bundleIDs = bundleIDs.slice(0, -1);
            bundleIDs = bundleIDs.replaceAll("ID=", "");
            bundleIDs = bundleIDs.split(",");
            //console.log(bundleIDs);
            $.each(bundleIDs, function(key, value) {
              	var bundleID = value;
              	console.log("Adding product to cart 3", bundleID);
              	console.log("Amount: ", productInfo["quantity"]);
            	CartJS.addItem(bundleID, productInfo["quantity"]);
            });
            productAdded = true;
          } else {
            CartJS.addItem(productInfo["id"], productInfo["quantity"]);
            productAdded = true;
          }
        }
      }
    
      if(productAdded == true ) {
        $(document).on('cart.requestComplete', function(event, cartInfo) {
        	jQuery.getJSON('/cart.js', function(cart) {
            console.log(cart);
            var cartSubTotal = cart.items_subtotal_price / 100;
            jQuery('.bagToggle sup').html(cart.item_count);
            jQuery('.buyGif').addClass('active');
            jQuery('.buyGif img').attr('src', 'https://cdn.shopify.com/s/files/1/1196/2016/t/2/assets/add-to-cart-1.gif?v=12313133199907157499');
            setTimeout(function() { jQuery('.buyGif').removeClass('active') }, 1200);
            console.log(cart.items);
            if(jQuery('.mini-cart-info').length) {
              jQuery('.mini-cart-info table tbody').html('');
            } else {
              jQuery('.noResults').remove();
              var cartResults = '<form action="/cart" method="post" novalidate="" class="cart" id="mini-cart"><div class="mini-cart-info"><table><tbody></tbody></table></div>';
              cartResults += '<div class="mini-cart-total"><table><tbody><tr><td><b>Subtotal :</b></td><td class="miniSubTotal">$'+ cartSubTotal + '</td></tr></tbody></table></div>';
              cartResults += '<div class="viewCart"><a class="checkoutlink" href="/cart">Check Out</a></div></form>';
              jQuery('.shopActionsPanel .panelInfo').append(cartResults);
            }
            for(var key in cart.items) {
              var cartItem = cart.items[key];
              var lineItem = parseInt(key) + 1;
              var engraving = (cartItem.product_type === "Engraving") ? true : false;
              var itemRow = "";
              if(engraving == true) {
                itemRow = '<tr class="engraving"><td colspan="5"><p class="withEngraving">+</p></td></tr><tr class="engraving">';
              } else {
              	itemRow = "<tr>";
              }
              if((cartItem.product_type == "Totem" || cartItem.product_type == "Totem Belt" || cartItem.product_type == "Signature Charm Bracelet") && cartItem.product_title.indexOf('Bracelet') != -1) {
                itemRow += "<td class='image'><img src='" + cartItem.image.replace("products/", "products/THUMB-") +"' class='totemCartImage' /></td>";
              } else if(engraving == false) {
                itemRow += "<td class='image'><img src='" + cartItem.image +"' /></td>";
              }
              if(engraving == true) {
                itemRow += '<td class="name" colspan="2">';
              } else {
              	itemRow += '<td class="name">';
              }
              if(this.product_type != "Totem" || this.product_type != "Totem Belt" || this.product_type != "Signature Charm Bracelet") {
                itemRow += '<a href="'+ cartItem.url +'">';
              }
              itemRow += cartItem.product_title;
              if(this.product_type != "Totem" || this.product_type != "Totem Belt" || this.product_type != "Signature Charm Bracelet") {
                itemRow += '</a>';
              }
              itemRow += '<div>';
              for (var index in cartItem.options_with_values){
                var option = cartItem.options_with_values[index];
                if(option.value != "Default Title" && option.value != "Default") {
                  if( option.value == "None" || option.value == "Hand Stamping" || option.value == "Engraving in Script" || option.value == "Engraving in Block Letters") {
                    itemRow += "<small>Personalization: " + option.value + "</small><br/>";
                  } else if( option.value =="Gold with Diamond" || option.value == "Sterling Silver") {
                    itemRow += "<small>Closure Color: " + option.value + "</small><br/>";
                  } else {
                    itemRow += "<small>" + option.name + ": " + option.value + "</small><br/>";
                  }
              	}
              }
              var obj = cartItem.properties;
              if(obj !== null){
                var extraOptions = Object.keys(obj).map(function (key) { 
                  if(obj[key]!="" && key != "Bracelet Order" && key != "Bracelet Number" && key != "Engraving for"){
                    return("<small>" + key + ": <span class='cartPersonalization'>" +obj[key] + "</span></small><br/>");
                  } 
                });
                extraOptions = extraOptions.toString();
              	extraOptions = extraOptions.replace(",", "");
              	itemRow += extraOptions;
              }
              itemRow += '</div></td>';             
              itemRow += '<td class="quantity">x&nbsp;' + cartItem.quantity + '</td>';
              var price = cartItem.price / 100;
              itemRow += '<td class="total">$'+ price +'</td>';
              itemRow += '<td class="remove"><a href="#" data-id="'+ lineItem +'" class="removeCartItem"><i class="fal fa-times"></i></a></td>';
              itemRow += '</tr>';
              console.log(itemRow);
              jQuery('.mini-cart-info table tbody').append(itemRow);
            }
            jQuery('#cartCount').html(cart.item_count);
            jQuery('.miniSubTotal').html("$" + cartSubTotal);
            jQuery('.bagToggle')[0].click();
          });
        });
	  }
  });
});

/*
<tr>                          
  <td class="image"><img src="//cdn.shopify.com/s/files/1/1442/5650/products/WR142.10k.D_75x75.jpg?v=1628775665"></td>
  <td class="name"><a href="/products/seven-stone-stack-band-in-gold-with-diamonds?variant=18584645140553">Classic Diamond Stack Band</a>  
    <div>
      <small>Size: 6</small><br>    
    </div>
  </td>
  <td class="quantity">x&nbsp;1</td>
  <td class="total">$295</td>
  <td class="remove"><a href="#" data-id="1" class="removeCartItem"><i class="fal fa-times"></i></a></td>
</tr>
*/